/* CUSTOM buy-total — zeigt im Add-to-Cart-Button live die Stueckzahl × Gesamtpreis
   (wie beim Voucher). Wirkt auf jeden Button mit [data-buy-total] (Keramik, Coffee,
   Workshop), liest Stueckzahl aus dem verknuepften quantity-Input. */
(function () {
  function formatMoney(cents, format) {
    format = format || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function f(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cee = parts[1] ? decimal + parts[1] : '';
      return dollars + cee;
    }
    var m = format.match(ph);
    var t = m ? m[1] : 'amount';
    var value;
    switch (t) {
      case 'amount': value = f(cents, 2); break;
      case 'amount_no_decimals': value = f(cents, 0); break;
      case 'amount_with_comma_separator': value = f(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = f(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = f(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = f(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = f(cents, 2, "'", '.'); break;
      default: value = f(cents, 2);
    }
    return format.replace(ph, value);
  }

  function wire(btn) {
    var unit = parseInt(btn.getAttribute('data-unit-price'), 10);
    if (isNaN(unit)) return;
    var fmt = btn.getAttribute('data-money-format') || '{{amount}}';
    var labelEl = btn.querySelector('span') || btn;
    var base = (btn.getAttribute('data-base-label') || labelEl.textContent || '').trim();
    var form = btn.form || btn.closest('form');

    function qtyInput() {
      var q = (form && form.elements) ? form.elements['quantity'] : null;
      if (!q) q = document.querySelector('input[name="quantity"]');
      return q;
    }
    function qty() {
      var q = qtyInput();
      var n = q ? parseInt(q.value, 10) : 1;
      return (!n || n < 1) ? 1 : n;
    }
    function render() {
      if (btn.disabled) return; // 'Sold out' / 'Unavailable' unangetastet lassen
      labelEl.textContent = base + ' · ' + formatMoney(unit * qty(), fmt);
    }

    var q = qtyInput();
    if (q) {
      ['change', 'input'].forEach(function (e) { q.addEventListener(e, render); });
      var qi = q.closest('quantity-input');
      if (qi) qi.addEventListener('click', function () { setTimeout(render, 0); });
    }
    render();
  }

  function init() {
    document.querySelectorAll('[data-buy-total]').forEach(wire);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
